import { PermissionActionType } from "@/constants/permissions"
import { usePermissionManager } from "@/hooks/usePermissionManager"

interface UseSalesOrderPermissionsReturn {
  canCreate: boolean
  canView: boolean
  isReadonly: boolean
}

export const useSalesOrderPermissions = (): UseSalesOrderPermissionsReturn => {
  const { hasPermissions } = usePermissionManager()

  const canCreate = hasPermissions([PermissionActionType.SALES_ORDER_CREATION])
  const canView = hasPermissions([PermissionActionType.SALES_ORDER_VIEW, PermissionActionType.SALES_ORDER_CREATION])
  const isReadonly = !canCreate

  return {
    canCreate,
    canView,
    isReadonly,
  }
}
